import BidSearch from '~/features/bidSearch';
import { useUserContext } from '~/hooks';

export default function Bids() {
  const { loggedInUser } = useUserContext();

  return (
    <>
      {loggedInUser?.isAdmin ? (
        <BidSearch />)
        : (
          null
        )}
    </>

  );
}
